import AddMetaDescription from './add-meta-description.container';

export default AddMetaDescription;
